<div class="modal fade" id="modalLoginRE" tabindex="-1" role="dialog" aria-labelledby="modalLoginRE" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal_header m_header">
                <h5 class="modal-title" id="exampleModalLabel">Sou colaborador Eurofarma</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
           
            <div class="modal-body">
                <form #loginForm="ngForm">
                    <div class="form-group">
                        <label for="start" class="col-form-label">RE</label>
                        <input id="re" name="re" type="string" class="form-control" ngModel required/>
                        <div *ngIf="loginForm.controls.re?.touched && loginForm.controls.re?.invalid" class="text-danger">
                            <span>{{'loginWithRe.reRequired'|translate}}</span>
                        </div>
                    </div>

                    <div *ngIf="!isForeign" class="form-group">
                        <label for="cpf" class="col-form-label">CPF</label>
                        <input [disabled]="isForeign" id="cpf" name="cpf" type="text" class="form-control" mask="000.000.000-00" ngModel required/>
                        <div *ngIf="loginForm.controls.cpf?.touched && loginForm.controls.cpf?.invalid" class="text-danger">
                            <span>{{'loginWithRe.cpfRequired'| translate}}</span>
                        </div>
                    </div>

                    <div *ngIf="isForeign" class="form-group">
                        <label for="foreignId" class="col-form-label">{{'loginWithRe.foreignId'|translate}}</label>
                        <input id="foreignId" name="foreignId" type="text" class="form-control" ngModel required/>
                        <div *ngIf="loginForm.controls.foreignId?.touched && loginForm.controls.foreignId?.invalid" class="text-danger">
                            <span>{{'loginWithRe.foreignIdRequired'| translate}}</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="dateOfBirth" class="col-form-label">{{'birthDate'|translate}}</label>
                        <input id="dateOfBirth" name="dateOfBirth" type="date" class="form-control" ngModel required/>
                        <div *ngIf="loginForm.controls.dateOfBirth?.touched && loginForm.controls.dateOfBirth?.invalid" class="text-danger">
                            <span>{{'loginWithRe.birthDateRequired'|translate}}</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="rhArea" class="col-form-label">{{'unit'|translate}}</label>
                        <select id="rhArea" name="rhArea" type="text" class="form-control" ngModel required>
                            <option *ngFor="let area of rhAreas" [value]="area">{{area}}</option>
                        </select>
                        <div *ngIf="loginForm.controls.rhArea?.touched && loginForm.controls.rhArea?.invalid" class="text-danger">
                            <span>{{'loginWithRe.unityRequired'|translate}}</span>
                        </div>
                    </div>

                    <div class="form-check">
                        <input id="isForeign" name="isForeign" type="checkbox" class="form-check-input" [(ngModel)]="isForeign"/>
                        <label for="isForeign" class="form-check-label">{{'loginWithRe.foreign'|translate}}</label>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button class="btn btn-primary" (click)="onSubmit()" [disabled]="!isFormValid">{{'enter'|translate}}</button>
            </div>
        </div>
    </div>
</div>